"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.convoTags.name': '对话标签',
    'tools.convoTags.description': '根据上下文为对话添加相关标签',
};
